import { useNavigate, useParams } from 'react-router';
import { useChatForInstance, useInstances } from '../hooks/useApi';
import { useEffect } from 'react';

const AGENT_BY_KIND: Record<string, string> = {
  image_360: 'fal-360-expert',
  image_2d: 'fal-image-expert',
  video: 'fal-video-expert',
  avatar: 'fal-avatar-expert',
  audio: 'fal-audio-expert',
  three_d: 'fal-3d-expert',
  mixed: 'fal-pipeline-orchestrator',
};

/**
 * 1:1 instance ↔ chat. Esta página existe solo para resolver el chat de la
 * instance (creándolo si no existe) y redirigir. El operador nunca ve esta
 * vista — pasa de largo al chat. Las refs y el brief están accesibles desde
 * el panel lateral del chat y el botón "Brief" del header.
 */
export function InstancePage() {
  const { projectSlug, instanceSlug } = useParams();
  const { data: instances } = useInstances(projectSlug);
  const instance = instances?.find((i) => i.slug === instanceSlug);
  const navigate = useNavigate();
  const agentSlug = instance ? AGENT_BY_KIND[instance.kind] ?? 'fal-pipeline-orchestrator' : undefined;
  const { data: chat } = useChatForInstance(instance?.id, agentSlug);

  useEffect(() => {
    if (chat?.id) navigate(`/chats/${chat.id}`, { replace: true });
  }, [chat?.id, navigate]);

  return (
    <div className="p-3 sm:p-6 max-w-5xl mx-auto text-slate-400 text-sm">
      Abriendo {instance?.name ?? instanceSlug}…
    </div>
  );
}
